import * as virtualBundlesApi from '../../services/virtualBundleService'
import { formatVirtualBundleData } from '../../mappers/virtualBundleMapper'
import * as types from './actionTypes'
import { showNotification } from 'store/notification/actionCreator'
import { fetchInventorySamples } from 'services/inventoryService'
import { SAMPLE } from 'enums/Tabs'
import { samplesResponseToSamples } from 'mappers/inventoryMapper'
import * as itemApi from '../../services/itemService'
import * as itemMapper from '../../mappers/itemMapper'
import { cloneDeep, first, isEmpty, partition } from 'lodash'
import * as shipmentMapper from '../../mappers/shipmentMapper'
import * as shipmentApi from '../../services/shipmentService'
import moment from 'moment'

export function getVirtualBundles(params, csvDownload = false, page = 1, rowsPerPage = 10, totalRowsCount = 10) {
  return (dispatch) => {
    if (csvDownload) {
      dispatch(setCSVDownloadPending(true))
    } else {
      dispatch(setVirtualBundlesRequestPending(true))
    }
    const size = csvDownload ? totalRowsCount : rowsPerPage
    const pageNumber = csvDownload ? 0 : page-1
    virtualBundlesApi
      .getVirtualBundleApi(params, pageNumber, size)
      .then((result) => {
        if (result?.data?.virtual_bundles?.length > 0) {
          const formattedData = formatVirtualBundleData(
            result?.data?.virtual_bundles
          )
          if (!csvDownload) {
            dispatch(
              setVirtualBundlesRequestSuccess(
                formattedData,
                result?.data?.total_count
              )
            )
          } else {
            dispatch(setCSVDownloadSuccess(formattedData))
          }
        } else {
          dispatch(setVirtualBundlesRequestSuccess([], 0))
        }
      })
      .catch(() => {
        dispatch(
          showNotification(
            true,
            'Something went wrong while fetching virtual bundles. Please try again.'
          )
        )
      })
      .finally(() => {
        dispatch(setCSVDownloadPending(false))
        dispatch(setVirtualBundlesRequestPending(false))
      })
  }
}
function getTcins(groups = []) {
  return groups.map((group) => {
    return Number(group?.parent_tcin)
  })
}

function getChildTcin(items = []) {
  const tcins = items.reduce((acc, item) => {
    ;(item?.childTcins || []).forEach((child) => {
      const childTcin = Number(child?.tcin)
      if (!Number.isNaN(childTcin)) {
        acc.push(childTcin)
      }
    })
    return acc
  }, [])

  return Array.from(new Set(tcins))
}

export function setCSVDownloadPending(isPending) {
  return {
    type: types.SET_VIRTUAL_BUNDLES_CSV_DOWNLOAD_PENDING,
    payload: isPending,
  }
}
export function setCSVDownloadSuccess(data) {
  return {
    type: types.SET_VIRTUAL_BUNDLES_CSV_DOWNLOAD_SUCCESS,
    payload: data,
  }
}
export function setVirtualBundlesRequestPending(isPending) {
  return {
    type: types.SET_VIRTUAL_BUNDLES_REQUEST_PENDING,
    payload: isPending,
  }
}

export function getVirtualBundleRequestPending(isPending) {
  return {
    type: types.GET_A_VIRTUAL_BUNDLES_REQUEST_PENDING,
    payload: isPending,
  }
}

export function setPage(page) {
  return {
    type: types.SET_VIRTUAL_BUNDLES_PAGE,
    payload: page,
  }
}
export function setRowsPerPage(rowsPerPage) {
  return {
    type: types.SET_VIRTUAL_BUNDLES_ROWS_PER_PAGE,
    payload: rowsPerPage,
  }
}

export function setVirtualBundlesRequestSuccess(data, count) {
  return {
    type: types.SET_VIRTUAL_BUNDLES_REQUEST_SUCCESS,
    payload: { data: data, totalRowsCount: count },
  }
}

export function setSelectedVirtualBundeDetails(data) {
  return {
    type: types.SET_SELECTED_VIRTUAL_BUNDLE_DETAILS,
    payload: data,
  }
}

export function getAVirtualBundleDataSuccess(data, totalCount, pagesCount) {
  return {
    type: types.GET_A_VIRTUAL_BUNDLE_DATA_SUCCESS,
    payload: { data, totalCount, pagesCount },
  }
}
export function updateSampleFieldsData(data = {}) {
  return {
    type: types.VIRTUAL_BUNDLE_CALL_EDIT_FIELDS_API,
    payload: data,
  }
}
export function showPopup(item) {
  const { imageUrl, sampleImageDPURL, sampleImageUrl, ...rest } = item
  return {
    type: types.SHOW_VIRTUAL_BUNDLE_POPUP,
    payload: { item: rest },
  }
}
export function closePopup() {
  return {
    type: types.CLOSE_VIRTUAL_BUNDLE_POPUP,
  }
}

export const getAVirtualBundleFromSearch = (parentTcin = '') => {
  return (dispatch) => {
    if (!parentTcin) {
      return
    }
    dispatch(getVirtualBundleRequestPending(true))
    const requestPayload = {
      requestPayload: {
        include_filters: {
          virtual_bundle_parent_ids: [Number(parentTcin)],
          ordered_start_date: '2024-01-01',
          ordered_end_date: moment().format('YYYY-MM-DD'),
        },
        exclude_filters: {},
      },
    }
    let totalRowsCount
    let filterNFList = {}
    return fetchInventorySamples(requestPayload, SAMPLE, 1, 350)
      .then((orderResult) => {
        const {
          data: { total_count = 0, filter_list_notfound = {} },
        } = orderResult
        totalRowsCount = total_count
        filterNFList = Object.assign({}, filter_list_notfound)
        return samplesResponseToSamples(orderResult)
      })
      .then((samples = []) => {
        return shipmentApi
          .fetchShipments(
            samples
              .map((it) => it.shipmentId)
              .filter((shipmentId) => shipmentId)
          )
          .then((shipmentResult) =>
            shipmentMapper.shipmentsResponseToShipments(
              shipmentResult?.data?.shipments
            )
          )
          .then((shipments) => {
            const listOfTcins = samples
              .map((it) => it.tcin)
              .filter((tcin) => !!tcin)
            const finalListOfTcins = Array.from(new Set([...listOfTcins]))
            let shipmentMap = new Map(
              shipments.map((shipment) => [shipment.shipmentId, shipment])
            )
            let orderResults = [].concat.apply(
              samples.map((order) =>
                Object.assign({}, order, shipmentMap.get(order.shipmentId))
              )
            )
            if (isEmpty(finalListOfTcins) || !finalListOfTcins[0]) {
              dispatch(getAVirtualBundleDataSuccess(orderResults))
            } else {
              return itemApi
                .getItemsGraphQL(finalListOfTcins)
                .then((itemResults) =>
                  itemMapper.itemsResponseToItems(itemResults)
                )
                .then((items) => {
                  let itemMap = new Map(
                    items.map((item) => [item?.tcin?.toString(), item])
                  )
                  orderResults = [].concat.apply(
                    orderResults.map((order) =>
                      Object.assign(
                        {},
                        order,
                        itemMap.get(order?.tcin?.toString())
                      )
                    )
                  )
                  dispatch(getAVirtualBundleDataSuccess(orderResults))
                })
            }
          })
      })
      .catch((e) => {
        dispatch(
          showNotification(
            true,
            'Something went wrong while fetching virtual bundle data. Please try again.'
          )
        )
      })
      .finally(() => {
        dispatch(getVirtualBundleRequestPending(false))
      })
  }
}

function getItems(ids = []) {
  return itemApi
    .getItemsGraphQL(ids)
    .then((itemResult) => itemMapper.itemsResponseToItems(itemResult))
}
export function getAVirtualBundleFromItems(
  args = [],
  successCallBack = () => {}
) {
  return (dispatch) => {
    dispatch(getVirtualBundleRequestPending(true))
    args = Array.from(new Set(args))
    let selectedParentInfo = {}
    return getItems(args)
      .then((result) => {
        selectedParentInfo = cloneDeep(result)
        return getChildTcins(result)
      })
      .then((items) => {
        let invalidItems = []
        items.forEach((it) => {
          if (
            (it.vendorId === null && !it.isParent) ||
            it.lifecycleState === 'HISTORICAL'
          ) {
            invalidItems.push(it)
          }
        })
        var validItems = items.filter(function (e) {
          return invalidItems?.indexOf(e) === -1
        })
        return Promise.all([invalidItems, validItems])
      })
      .then(([invalidItems, validItems]) => {
        dispatch(setVirtualBundlesFromItems(validItems))
        dispatch(setVirtualBundleParent(selectedParentInfo))
        successCallBack()
      })
      .catch((error) => {
        dispatch(
          showNotification(
            true,
            'Something went wrong while fetching virtual bundle data. Please try again.'
          )
        )
        dispatch(getVirtualBundleRequestPending(false))
      })
      .finally(() => {
        dispatch(getVirtualBundleRequestPending(false))
      })
  }
}
function getChildTcins(start = []) {
  const [parents = [], baseItems] = partition(
    start,
    (result) => result.isParent
  )
  return parents?.length > 0
    ? Promise.all([
        baseItems,
        getItems(
          parents?.map((parent) =>
            (parent?.childTcins || []).map((i) => i.tcin)
          )
        ).then((items = []) => {
          const finalItemList = items?.map((itemObj) => {
            const itemParent = parents?.find(
              (pobj) =>
                (pobj?.childTcins || [])
                  ?.map((cobj) => cobj.tcin)
                  ?.indexOf(itemObj.tcin) !== -1
            )
            itemObj['quantity'] =
              (itemParent?.childTcins || [])?.find(
                (obj) => obj.tcin === itemObj.tcin
              )?.thresholdQuantity || Number(1)
            return itemObj
          })
          return getChildTcins(finalItemList)
        }),
      ]).then((r) => r.flat(2))
    : baseItems
}

export function setVirtualBundlesFromItems(data = []) {
  return {
    type: types.SET_VIRTUAL_BUNDLES_FROM_ITEMS,
    payload: { data: [...data] },
  }
}

export function setVirtualBundleParent(data = []) {
  return {
    type: types.SET_VIRTUAL_BUNDLE_PARENT,
    payload: { data: first(data) },
  }
}
